import { Firehose, STS } from "aws-sdk";
import { ClientConfiguration } from "aws-sdk/clients/firehose";
import { injectable } from "inversify";
import { ITracker } from "../../domain/interfaces/tracker.interface";
import { BOBEnvironment } from "../../express/bob-environment";
import { ITrackingEvent } from "../../domain/interfaces/tracking-event.interface";

@injectable()
export default class SpAnalyticsTracker implements ITracker {

	private sts = new STS();
	private stsCredentials: STS.Credentials;

	public async trackEvent(trackingEvent: ITrackingEvent): Promise<void> {

		if (process.env.BOB_TRACKING_ROLE === undefined) {
			return;
		}

		const firehose = new Firehose(await this.getRoleAccessParams());

		await firehose.putRecord({
			Record: {Data: JSON.stringify(this.getPayload(trackingEvent))},
			DeliveryStreamName: "sp-analytics-bob-prd"
		}).promise();
	}

	private getPayload(trackingEvent: ITrackingEvent): {[key: string]: any} {
		return {
			timestamp: new Date().toISOString(),
			category: trackingEvent.category,
			action: trackingEvent.action,
			label: trackingEvent.label,
			timeElapsed: trackingEvent.timeElapsed || 0,
			product: "Bob",
			environment: BOBEnvironment.getEnvironment(),
			team: "devops",
			url: trackingEvent.url,
			eventData: trackingEvent.eventData || ""
		};
	}

	private async getRoleAccessParams(): Promise<ClientConfiguration> {
		if (this.stsCredentials === undefined || this.isExpired(this.stsCredentials)) {

			const assumeRole = await this.sts.assumeRole({
				RoleArn: process.env.BOB_TRACKING_ROLE as string,
				RoleSessionName: "bobtracking"
			}).promise();

			this.stsCredentials = assumeRole.Credentials as STS.Credentials;

		}

		return {
			accessKeyId: this.stsCredentials.AccessKeyId,
			secretAccessKey: this.stsCredentials.SecretAccessKey,
			sessionToken: this.stsCredentials.SessionToken,
			region: "eu-west-1"
		};
	}

	private isExpired(stsCredentials: STS.Credentials) {
		const now = new Date();
		return now.getTime() > stsCredentials.Expiration.getTime();
	}
}
